import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SiselseCondo } from "src/app/interfaces/siselse";
import { FunctionsService } from "src/app/services/functions/functions.service";
import { SiselseService } from "src/app/services/siselse/siselse.service";

import { Location } from "@angular/common";
@Component({
  selector: "siselse-list-interphones",
  templateUrl: "./interphones-list.component.html",
})
export class SiselseListInterphonesComponent implements OnInit {
  interphones: { no: string; tel: string }[] = [];
  originalInterphones: { no: string; tel: string }[] = [];
  constructor(
    private funcService: FunctionsService,
    private siselse: SiselseService,
    private location: Location
  ) {}
  @Input() condo: SiselseCondo;
  @Input() limit: number = 1;

  @Output() onSave: EventEmitter<void> = new EventEmitter();
  saveStatus = false;
  ngOnInit() {
    console.log(this.condo);
    if (this.limit > 0) {
      this.interphones.push({
        no: this.condo.frentecalle,
        tel: this.condo.telefono,
      });

      if (this.limit === 2) {
        this.interphones.push({
          no: this.condo.frentecalle2,
          tel: this.condo.celular1,
        });
      }
    }
    // Almacenar una copia de los datos originales
    this.originalInterphones = JSON.parse(JSON.stringify(this.interphones));

    console.log(this.interphones);
  }

  saveDatos() {
    this.saveStatus = true;
    console.log(this.interphones);

    // Verificar si los datos han cambiado
    const telChanged =
      this.interphones[0].tel !== this.originalInterphones[0].tel;
    const celularChanged =
      this.limit === 2 &&
      this.interphones[1]?.tel !== this.originalInterphones[1]?.tel;

    if (telChanged || celularChanged) {
      let title = "Cambio de interfono";
      if (telChanged && celularChanged) {
        title = "Cambio de interfonos 1 y 2";
      } else if (telChanged) {
        title = "Cambio de interfono 1";
      } else if (celularChanged) {
        title = "Cambio de interfono 2";
      }
      console.log("Los datos han sido modificados");
      // Aquí puedes utilizar el arrayDeDatos como desees, por ejemplo, enviarlo a un servicio para almacenarlo.
      this.funcService
        .showConfirm(
          title,
          "Los datos serán guardados y reemplazados, generando un ticket para el cambio de interfono. ¿Desea continuar?",
          "Cancelar",
          "Guardar"
        )
        .then((save) => {
          if (save) {
            console.log(this.condo);
            this.siselse
              .setStatusCondo(
                this.condo.idcasa,
                this.condo.status === "Moroso" ? false : true,
                this.condo.calle,
                this.condo.numero,
                telChanged ? this.interphones[0].tel : undefined,
                celularChanged ? this.interphones[1]?.tel : undefined
              )
              .then((res) => {
                // Actualizar las propiedades de this.condo
                this.condo.telefono = this.interphones[0].tel;
                this.condo.celular1 = this.interphones[1]?.tel;

                // Buscar y actualizar el objeto correspondiente en this.siselse.condos
                const condoIndex = this.siselse.condos.findIndex(
                  (c) => c.idcasa === this.condo.idcasa
                );
                if (condoIndex !== -1) {
                  this.siselse.condos[condoIndex].telefono =
                    this.condo.telefono;
                  this.siselse.condos[condoIndex].celular1 =
                    this.condo.celular1;
                }

                console.log(res);
                // Generar mensajes de ticket
                if (telChanged) {
                  this.generateTicket(1, {
                    no: this.interphones[0].no,
                    tel: this.interphones[0].tel,
                  });
                }
                if (celularChanged) {
                  this.generateTicket(2, {
                    no: this.interphones[1].no,
                    tel: this.interphones[1].tel,
                  });
                }
                this.onSave.emit();
              });
          } else {
            this.saveStatus = false;
          }
        });
    } else {
      console.log("Los datos no han sido modificados");
      this.onSave.emit();
    }
  }

  generateTicket(inter_number: number, interfon: { no: string; tel: string }) {
    const message = `Cambio en la casa  ${this.condo.calle} ${this.condo.numero} en el interfon ${inter_number} con frente de calle ${interfon.no} con el teléfono ${interfon.tel}`;
    this.siselse
      .getAddTicket(this.condo.privada_idprivada, message, "57")
      .then((res) => {
        console.log(res);
      });
  }
}
